module.exports = __webpack_public_path__ + "img/fr.671cb78d.svg";